<template>
  <div class="">
    <h6 v-if="!loading" class="  " dir="ltr">

      {{ items['use_subscription_storage'] }}


      MB


      /

      {{ Math.round(parseInt(items['storage_size'])) }}

      MB

    </h6>
  </div>
</template>

<script>

export default {
  name: "DashboardStorageSize",
  data() {
    return {
      items: {},
      loading: true
    }
  },
  methods: {
    async loadData() {
      let req = await this.$store.dispatch("DashboardSubscription/siteModuleStatus");
      let resource_counter = await this.$store.dispatch("DashboardResource/getResources")
      this.items = req.data.data
      this.items['storage_size'] = resource_counter.data.data.storage_size
      this.loading = false
    }
  },
  async mounted() {
    await this.loadData();
  }
}
</script>

<style scoped>

</style>